import type { IErrorUserInvitation } from '@/shared/common/types/userInvitationError.type';

export const ErrorsUserInvitation: IErrorUserInvitation = {
  USER_ALREADY_EXISTS: 'Este correo ya está siendo utilizado por otra cuenta',
  INVITATION_ALREADY_EXISTS: 'Este correo ya tiene una invitación pendiente',
  INVITATION_NOT_FOUND: 'No se encontró la invitación',
  CANNOT_UPDATE_INVITATION_WITH_CURRENT_STATUS: 'No se puede actualizar la invitación con el estado actual',
} as const;
